export enum StatsDataEnum {
    CALCULATION = 'calculation',
    OFFER = 'offer',
    SUMMARY = 'summary',
    PRE_BUY_SUMMARY = 'pre_buy_summary',
    PAGE_TITLE = 'rakna_pris_din_forsakring',
    APPLICATION_NAME = 'webshop_se'
}
